'use client';
import { MicrosoftPickerErrorCode } from '#pplx/frontend/components/hooks/MicrosoftPickerErrorCode.js';
export class MicrosoftPickerError extends Error {
    code;
    constructor(code, message) {
        super(message);
        this.code = code;
        this.name = 'MicrosoftPickerError';
    }
}
export const CHANNEL_ID = 27;
export const AUTH_TIMEOUT = 20000;
export const PICKER_INIT_TIMEOUT = 5000;
export const MAX_PICKER_INIT_RETRIES = 1;
//# sourceMappingURL=useMicrosoftPicker.js.map